import type React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRefreshableSession } from '../utils';
import { OnboardingGate } from './OnboardingGate';
import { PATH } from './PATH';

export const SecuredRoutes: React.FC = () => {
    // Admit any refreshable session — even one whose access token has expired.
    // The 401 interceptor refreshes on the first request; only a failed refresh
    // (or explicit logout) sends the user to /login. Gating on a non-expired
    // access token here would log refreshable users out at the access-token
    // lifetime, before any request can trigger the refresh.
    //
    // A session then meets the onboarding gate, which renders the route or
    // sends the user to the wizard, the setup-in-progress page or home.
    return hasRefreshableSession() ? (
        <OnboardingGate />
    ) : (
        <Navigate replace to={PATH.LOGIN} />
    );
};
